const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Migrate entries with ZenQL', () => {
  describe('using zenQL preview migrating a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock('migrate_entries_zenql_simple_preview.json');

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries?zenql&simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });

  describe('using zenQL migrate a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock('migrate_entries_commit_zenql_simple.json');

    it(`should create one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?zenql&simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.errors).to.not.exist;
          expect(body?.migrateResult.created).to.equal(1);
          done();
        }
      );
    });
  });

  describe('using zenQL repeat the same migrate a single entry by contentTypeId and guid', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_zenql_simple_repeat.json'
    );

    it(`should return one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?zenql&simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('using zenQL preview migrating a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock('migrate_entries_zenql_linked_preview.json');

    it(`should return 19 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries?zenql&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(body?.entries?.migratortron?.totalCount).to.equal(19);
          done();
        }
      );
    });
  });

  describe('using zenQL migrate a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock('migrate_entries_commit_zenql_linked.json');

    it(`should create 19 entries and update one with a second pass`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?zenql&linked',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(19);
          expect(jpath('existing.*.totalCount', body)).to.equal(0);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(19);

          expect(body?.migrateResult.created).to.equal(19);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('using zenQL repeat the same migrate a single entry by contentTypeId and guid with 18 linked entries', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_zenql_linked_repeat.json'
    );

    it(`should return 19 entries`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?zenql&linked&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(19);
          expect(jpath('existing.*.totalCount', body)).to.equal(19);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
